<template>
	<Bar
		:chart-options="chartOptions"
		:chart-data="chartData"
		css-classes="bar-chart"
	/>
</template>

<script>
import { Bar } from 'vue-chartjs';
import {
	Chart as ChartJS,
	Title,
	Tooltip,
	BarElement,
	CategoryScale,
	LinearScale,
} from 'chart.js';
import { fetchMerchantTransactionList } from '@/api/merchant';
import { commonError } from '@/common/dialog';
import { mapGetters } from 'vuex';

ChartJS.register(Title, Tooltip, BarElement, CategoryScale, LinearScale);
export default {
	name: 'PaymentStatisticsChart',
	components: { Bar },
	props: { rangeDate: Object },
	data() {
		return {
			// rangeDate: null,
			transactionList: [],
			chartData: {
				labels: [],
				datasets: [
					{
						backgroundColor: '#f87979',
						data: [],
					},
				],
			},
			chartOptions: {
				responsive: true,
				maintainAspectRatio: false,
			},
		};
	},
	computed: {
		...mapGetters('assets', ['assets']),
		janopayInfo() {
			return this.assets.find(item => {
				return item.code === 'JPYS';
			});
		},
	},
	watch: {
		rangeDate: {
			handler() {
				this.loadTransactionList();
			},
			deep: true,
		},
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.loadTransactionList();
		},
		async loadTransactionList() {
			const params = {
				...this.$route.query,
				...this.$route.params,
				regdate_start: this.$dayjs(new Date(this.rangeDate.start))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.rangeDate.end).endOf('day').valueOf(),
				no_paging: 1,
				status: 'APPROVED',
				asset_seq: this.janopayInfo.seq,
			};

			await fetchMerchantTransactionList(params)
				.then(({ data }) => {
					this.transactionList = data;
					this.getChartData();
				})
				.catch(commonError);
		},
		getChartData() {
			const startDate = this.$dayjs(this.rangeDate.start);
			const endDate = this.$dayjs(this.rangeDate.end);
			const diff = Math.floor(endDate.diff(startDate, 'day', true));
			const labels = [];
			const datas = [];
			let label, sum;
			for (let i = 0; i < diff + 1; i++) {
				label = startDate.add(i, 'd').format('YYYY.MM.DD');
				sum = 0;
				this.transactionList.forEach(item => {
					if (this.$dayjs(item.regdate).format('YYYY.MM.DD') === label) {
						if (item.transaction_type === 'PAYMENT') {
							sum += item.net_amount * 1;
						} else if (item.transaction_type === 'REFUND') {
							sum -= item.net_amount * 1;
						}
					}
				});
				labels.push(label);
				datas.push(sum);
			}
			this.chartData.labels = labels;
			this.chartData.datasets[0].data = datas;
		},
	},
};
</script>
